export default __webpack_public_path__ + "static/media/001-soy-milk.bcf9b239.svg";